<template>
  <div class="list" ref="wrapper">
    <div>
      <div class="list-module">
        <span class="list-title">{{title}}</span>
        <ul class="list-content">
          <li class="list-item active" v-if="city.length === 1">地址未知</li>
          <li class="list-item active" v-if="city.length === 2">{{city[0]}}<i class="iconfont">&#xe757;</i>{{city[1]}}</li>
          <li class="list-item active" v-if="city.length === 3">{{city[0]}}<i class="iconfont">&#xe757;</i>{{city[1]}}<i class="iconfont">&#xe757;</i>{{city[2]}}</li>
        </ul>
        <span class="w-icon" v-for="(item, i) in iconSrc" :key="i" :style="{backgroundImage: 'url('+item+')'}"></span><span class="list-title tip">{{weather}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CityList',
  props: {
    city: Array,
    weather: String,
    iconSrc: Array,
    title: String
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
@import "~styles/varibles.styl"
.list 
  position: absolute;
  overflow: hidden;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px; 
  .list-module
    padding-top: 15px;
    background #ffffff
    .list-title
      font-size 15px;
      padding-left 15px;
    .tip
      color $itemColor
      line-height 42px
      height 42px
    .list-content
      padding 0 31px 0 15px
      .list-item
        height 27px
        line-height 27px
        display inline-block
        padding 0 9px
        font-size 16px
        color #333333
        border 1px solid #d1d1d1;
        border-radius 8px
        margin-top 8px
      .active
        color #ffffff
        background #000000
    .list-content-all
      .list-item-title
        font-size 13px
        height 25px
        line-height 25px
        background #ededed
        color #6a6a6a
        padding-left 15px
      .city-name
        font-size 17px
        padding-left 15px
        height 39px
        line-height 39px
        color #333333
        border-bottom 1px solid #ededed
      .city-content
        padding 15px 24px 0 30px
        background #ededed
        rowCenter()
        flex-wrap wrap
        .city-child
          min-width 89px
          padding 0 4px
          height 27px
          line-height 27px
          background #ffffff
          font-size 14px
          text-align center
          margin-bottom 12px
          margin-right 9px
          border-radius 5px
    .w-icon
      display inline-block
      width 18px
      height 18px
      background-position center center
      background-repeat no-repeat
      background-size contain

</style>


// WEBPACK FOOTER //
// src/pages/CitySelect/components/list.vue